import { number, object, string } from '@gogame/schemas';

import { GROUP_ID } from './constants';

export const presetSchema = object({
  title: string().required('Name is required'),
});

export const addPresetSchema = presetSchema.shape({
  [GROUP_ID]: number(),
});
